var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"label":"prettyName","clearSearchOnBlur":() => true,"multiple":_vm.multiple,"options":_vm.adUsers,"placeholder":_vm.placeHolder},on:{"search":_vm.searchADUsers},model:{value:(_vm.internalSelectedUsers),callback:function ($$v) {_vm.internalSelectedUsers=$$v},expression:"internalSelectedUsers"}})
}
var staticRenderFns = []

export { render, staticRenderFns }